'use strict';

/**
 *  timeCueModule Module
 *
 * Description 策划中心 信息监控 实时线索 爆料监控
 * rebuild: SMG 2016-5-24
 */
angular.module('weiboMonitorModule', ['weiboConfigModule'])
    .controller('weiboMonitorController', ['$scope', '$state', '$window', '$q', '$filter', '$stateParams', 'trsHttpService', 'trsspliceString', 'modalDialog',
        function($scope, $state, $window, $q, $filter, $stateParams, trsHttpService, trsspliceString, modalDialog) {
            initStatus();
            initData();


            function initStatus() {

                $scope.page = {
                    'CURRPAGE': 0,
                    'PAGESIZE': 10,
                    'ITEMCOUNT': 0
                };
                $scope.data = {
                    items: '',
                    weiboCliques: '',
                    keywords: '',
                    selectedCliques: [],
                    start_pos: 0,
                    lastpage_no: 0,
                    interested_area: [],
                    interested_weibo: [],
                    related_weibo: [],
                };
                $scope.params = {
                    'serviceid': 'weiboSearchMgr',
                    'modelid': 'getArticles',
                    'page_no': $scope.page.CURRPAGE,
                    'page_size': $scope.page.PAGESIZE,
                };
                $scope.status = {
                    jumpToPageNum: 1,
                    showKeywords: '',
                    numbers: (function() { // 用于数字转字母
                        var array = [];
                        for (var i = 97; i <= 122; i++) {
                            array.push({ value: i });
                        }
                        return array;
                    })(),
                    checkedAll: true,
                    config: true, // 右侧指令是否显示
                };
            }

            /**
             * [initData description]初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                getConfigData().then(() => {
                    requestData();
                });
            }

            /**
             * [initBigPicsStatus description设置大图默认不展示]
             * @return {[type]} [description]
             */
            function initBigPicsStatus() {
                angular.forEach($scope.data.items, function(data, index, array) {
                    data.showBigPic = false;
                });
            }

            /**
             * [requestData description]数据请求函数(微博爆料数据分页获取)
             * @return {[obj]} [description]
             */
            function requestData() {
                // $scope.params.start_pos = $scope.data.start_pos;
                // $scope.params.lastpage_no = $scope.data.lastpage_no;
                $scope.params.content = {
                    'INTERESTED_AREA': getSelectedIdFromArr($scope.data.interested_area),
                    'INTERESTED_WEIBO': getSelectedIdFromArr($scope.data.interested_weibo),
                    'RELATED_WEIBO': getSelectedIdFromArr($scope.data.related_weibo),
                };
                $scope.params.search_word = angular.isDefined($scope.data.keywords) ? $scope.data.keywords : '';
                if (angular.isUndefined($scope.params.search_date) || $scope.params.search_date == '') {
                    let untildate = new Date();
                    let fromdate = new Date(untildate.getTime() - 30 * 24 * 60 * 60 * 1000);
                    $scope.params.search_date = $filter('date')(fromdate, 'yyyy-MM-dd') + ';' + $filter('date')(untildate, 'yyyy-MM-dd');
                }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, 'get').then(function(data) {
                    $scope.data.items = data.MAPRESULT.CONTENT.PAGEITEMS;
                    if ($scope.data.items.length > 0) {
                        initBigPicsStatus();
                        // $scope.data.start_pos = $scope.data.items[$scope.data.items.length - 1].CURRENTPOS;
                    }
                    $scope.page = {
                        CURRPAGE: data.MAPRESULT.CONTENT.PAGEINDEX + 1,
                        PAGESIZE: data.MAPRESULT.CONTENT.PAGESIZE,
                        ITEMCOUNT: data.MAPRESULT.CONTENT.TOTALITEMCOUNT,
                        PAGECOUNT: data.MAPRESULT.CONTENT.PAGETOTAL
                    };
                    $scope.data.lastpage_no = $scope.page.CURRPAGE;
                });
            }

            /**
             * [getConfigData description]  获取配置数据
             * @return {[type]} [description]
             */
            function getConfigData() {
                let defer = $q.defer();
                let params = {
                    'serviceid': 'weiboSearchMgr',
                    'modelid': 'getConfig',
                    // "user_id": "zhujs@qq.com",
                    // "department": 1,
                    // "tenantid": 115
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'get').then((data) => {
                    $scope.data.interested_area = angular.isDefined(data.MAPRESULT.CONTENT.INTERESTED_AREA) ? data.MAPRESULT.CONTENT.INTERESTED_AREA : [];
                    $scope.data.interested_weibo = angular.isDefined(data.MAPRESULT.CONTENT.INTERESTED_WEIBO) ? data.MAPRESULT.CONTENT.INTERESTED_WEIBO : [];
                    $scope.data.related_weibo = angular.isDefined(data.MAPRESULT.CONTENT.RELATED_WEIBO) ? data.MAPRESULT.CONTENT.RELATED_WEIBO : [];
                    defer.resolve();
                });
                return defer.promise;
            }

            /**
             * [saveConfigData description] 保存配置数据
             * @return {[type]} [description]
             */
            function saveConfigData() {
                let defer = $q.defer();
                let params = {
                    'serviceid': 'weiboSearchMgr',
                    'modelid': 'saveConfig',
                    // "user_id": "zhujs@qq.com",
                    // "department": 1,
                    // "tenantid": 115,
                    'content': {
                        INTERESTED_AREA: getSelectedIdFromArr($scope.data.interested_area),
                        INTERESTED_WEIBO: getSelectedIdFromArr($scope.data.interested_weibo),
                        RELATED_WEIBO: getSelectedIdFromArr($scope.data.related_weibo),
                    }
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'get').then((data) => {

                    defer.resolve();
                });
                return defer.promise;
            }

            /**
             * [getSelectedIdFromArr description] 获取数组中被选中的元素id，并用，隔开拼接成字符串
             * @param  {[type]} arr [description] 数组
             * @return {[type]}     [description]
             */
            function getSelectedIdFromArr(arr) {
                let selectedArr = arr.filter((item) => item.SELECTED == 1);
                return selectedArr.map((item) => item.ACCOUNT).join(',');
            }

            /**
             * [hideBigPics description隐藏幻灯片大图]
             * @return {[type]} [description]
             */
            /* $scope.hideBigPics = function(item) {
                item.showBigPic = false;
            };*/
            /**
             * [brokeMonitorSearch description;根据关键词检索(包含检索的分页列表信息)]
             * @param  {[type]} ev [description:按下空格也能提交]
             */
            $scope.queryListBySearchWord = function(ev) {
                if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                    $scope.params.page_no = 0;
                    $scope.status.jumpToPageNum = 1;
                    $scope.data.start_pos = 0;
                    $scope.data.lastpage_no = 0;
                    $scope.status.showKeywords = $scope.data.keywords;
                    requestData();
                }
            };

            /**
             * [pageChanged description]分页请求
             * @return {[type]} [description]
             */
            $scope.pageChanged = function() {
                $scope.params.page_no = $scope.page.CURRPAGE - 1;
                $scope.status.jumpToPageNum = $scope.page.CURRPAGE;
                requestData();
                gotoTop();
            };

            $scope.jumpToPage = function() {
                if ($scope.status.jumpToPageNum > $scope.page.PAGECOUNT) {
                    $scope.status.jumpToPageNum = $scope.page.PAGECOUNT;
                }
                $scope.params.page_no = $scope.status.jumpToPageNum - 1;
                requestData();
                gotoTop();
            };

            /**
             * [gotoTop description点击分页后，回到头部]
             * @return {[type]} [description]
             */
            function gotoTop() {
                $('html, body').animate({ scrollTop: 0 }, 'nomal');
            }

            /**
             * 将日期字符串转换为时间戳
             */
            $scope.timeStamp = function(item) {
                var date = new Date(Date.parse(item.DOCPUBTIME));
                return $filter('date')(date, 'yyyy-MM-dd HH:mm:ss').toString();
            };

            /**
             * [saveAndWatch description 保存并查看]
             * @return {[type]} [description]
             */
            $scope.saveAndWatch = function() {
                // $scope.data.keywords = ""; //清空检索词
                if ($scope.data.selectedCliques.length == 0) {
                    modalDialog.alertType('请选择集团微博', '', 'warning', false);
                    return;
                }
                var params = {
                    'serviceid': 'weibobomb',
                    'modelid': 'saveconfig',
                    'page_no': 0,
                    'page_size': $scope.page.PAGESIZE,
                    'accounts': trsspliceString.spliceString($scope.data.selectedCliques, 'ACCOUNT', ','),
                    'search_word': $scope.data.keywords,
                };
                if (!params.accounts) {
                    modalDialog.alertType('请选择集团微博', '', 'warning', false);
                    return;
                }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'get').then(function(data) {
                    requestData();
                });

            };

            /**
             * [clearKeywords description清除检索条件]
             * @return {[type]} [description]
             */
            $scope.clearKeywords = function() {
                $scope.status.showKeywords = $scope.data.keywords = '';
                requestData();
            };

            /**
             * [showLargeImgs description点击展示大图]
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            /* $scope.showBigPics = function(item) {
                initBigPicsStatus();
                item.showBigPic = true;
            };*/
            // 监听鼠标点击事件
            /* $window.addEventListener("storage", function(e) {
                angular.forEach($scope.data.items, function(data, index, array) {
                    if(data.showBigPic==true){
                        data.showBigPic= false;
                    }
                });
            });*/
            /**
             * [checkAll description]全选和反选
             * @return {[obj]} [description]
             */
            $scope.checkAll = function() {
                if ($scope.status.checkedAll) {
                    for (var i = 0; i < $scope.data.weiboCliques.length; i++) {
                        if ($scope.data.weiboCliques[i].SELECTED == 0) {
                            $scope.data.weiboCliques[i].SELECTED = 1;
                            $scope.data.selectedCliques.push($scope.data.weiboCliques[i]);
                        }
                    }
                    $scope.status.checkedAll = false;
                } else {
                    for (var i = 0; i < $scope.data.weiboCliques.length; i++) {
                        if ($scope.data.weiboCliques[i].SELECTED == 1) {
                            $scope.data.weiboCliques[i].SELECTED = 0;
                            $scope.data.selectedCliques = [];
                        }
                    }
                    $scope.status.checkedAll = true;
                }
            };

            /**
             * [deleteCheck description]删除选中
             * @return {[obj]} [description]
             */
            $scope.deleteCheck = function() {
                $scope.status.checkedAll = true;
                for (var i = 0; i < $scope.data.weiboCliques.length; i++) {
                    if ($scope.data.weiboCliques[i].SELECTED == 1) {
                        $scope.data.weiboCliques[i].SELECTED = 0;
                        $scope.data.selectedCliques = [];
                    }
                }
            };

            /**
             * [queryByDropdown description] test筛选条件触发后请求数据
             * @return {[type]}       [description] null
             */
            $scope.queryByDropdown = function() {
                $scope.params.search_date = !$scope.data.untildate ? '' : $scope.data.fromdate + ';' + $scope.data.untildate;
                requestData();
            };

            /**
             * [openConfig description] 打开选中栏目
             * @return {[type]} [description]
             */
            $scope.openConfig = function() {
                $scope.status.config = !$scope.status.config;
            };

            $scope.leaveButton = function() {
                $scope.status.isHover = false;
            };

            /**
             * [hasUnselected description] 数组中是否含有未选择的元素
             * @param  {[type]}  arr [description] 数组
             * @return {Boolean}     [description]
             */
            $scope.hasUnselected = function(arr) {
                return arr.some((item) => item.SELECTED == 0);
            };

            /**
             * [selectAll description] 数组全选/取消全选
             * @param  {[type]} arr [description] 数组
             * @return {[type]}     [description]
             */
            $scope.selectAll = function(arr) {
                if ($scope.hasUnselected(arr)) {
                    arr.map((item) => {
                        item.SELECTED = 1;
                        return item;
                    });
                } else {
                    arr.map((item) => {
                        item.SELECTED = 0;
                        return item;
                    });
                }
                saveConfigData().then(() => {
                    initData();
                });
            };

            /**
             * [selectItem description] 元素选择/取消选择
             * @param  {[type]} item [description] 元素
             * @return {[type]}      [description]
             */
            $scope.selectItem = function(item) {
                if (item.SELECTED == 0) {
                    item.SELECTED = 1;
                } else {
                    item.SELECTED = 0;
                }
                saveConfigData().then(() => {
                    initData();
                });
            };
        }
    ]);
